import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Card from "@mui/material/Card";
import axios from "axios";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import CoverLayout from "layouts/authentication/components/CoverLayout";
import { VERIFIKASI } from "utils";
import { useSiteAssets } from "context/SiteAssetsContext";
import { SITE_ASSET_KEYS } from "utils/siteAssets";

function VerifikasiPublik() {
  const { kode } = useParams();
  const { getAssetUrl } = useSiteAssets();
  const bgImage = getAssetUrl(SITE_ASSET_KEYS.BG_VERIFIKASI);
  const [loading, setLoading] = useState(true);
  const [result, setResult] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    axios
      .get(`${VERIFIKASI}${kode}`)
      .then((res) => setResult(res.data?.data))
      .catch((err) => setError(err.response?.data?.message || "Dokumen tidak valid"))
      .finally(() => setLoading(false));
  }, [kode]);

  return (
    <CoverLayout image={bgImage}>
      <Card sx={{ maxWidth: 480, mx: "auto" }}>
        <MDBox p={4} textAlign="center">
          <MDTypography variant="h4" fontWeight="medium" mb={1}>
            Verifikasi Dokumen Izin
          </MDTypography>
          <MDTypography variant="button" color="text" mb={3} display="block">
            TIALAI — Kabupaten Rote Ndao
          </MDTypography>

          {loading && <MDTypography>Memverifikasi...</MDTypography>}
          {!loading && error && (
            <MDBox>
              <MDTypography color="error" variant="h6">
                Tidak Valid
              </MDTypography>
              <MDTypography variant="button" color="text">
                {error}
              </MDTypography>
            </MDBox>
          )}
          {!loading && result?.valid && (
            <MDBox textAlign="left">
              <MDTypography color="success" variant="h6" mb={2} textAlign="center">
                Dokumen Valid
              </MDTypography>
              <MDTypography variant="button" display="block" mb={1}>
                <strong>Nomor Izin:</strong> {result.nomor_izin}
              </MDTypography>
              <MDTypography variant="button" display="block" mb={1}>
                <strong>Jenis Izin:</strong> {result.jenis_izin}
              </MDTypography>
              <MDTypography variant="button" display="block" mb={1}>
                <strong>Tanggal:</strong> {result.tanggal_izin}
              </MDTypography>
              <MDTypography variant="button" display="block">
                <strong>Status:</strong> {result.status}
              </MDTypography>
            </MDBox>
          )}
        </MDBox>
      </Card>
    </CoverLayout>
  );
}

export default VerifikasiPublik;
